module.exports = __webpack_public_path__ + "static/assets/6891af6b9c97590c34cbbc234d66d24c.png";